import { useRouter } from 'next/router';
import DynamicIcon from "./dynamic-icon";
import Image from "next/image";
import { prefix } from '../../lib/auth';
import Tooltips from './tooltip';
import ComingSoonText from './coming-soon-text';
import { getCachedBusiness } from '../../lib/utils';

const AppItem = ({ children, subtitle, icon, active, additionalclasses, peg, image, tag }) => {
    const cacheBusiness = getCachedBusiness();

    const router = useRouter();
    return (
        <Tooltips position={tag === 'Coming soon' ? 'bottom' : ''} content={tag}>
            <div onClick={() => { tag !== 'Coming soon' ? router.push(`http://${prefix()}${peg}.workpeg.com/${cacheBusiness}`) : null }} className={`flex w-full py-[11.29px] px-[9.86px] items-center custom-text-grey-800 ${tag === 'Coming soon' ? 'cursor-not-allowed' : 'cursor-pointer'} content-center justify-between hover:custom-bg-grey-50 group rounded-lg dropdown-option ${active ? 'dark:bg-grey-600 bg-white-50' : ''} ${additionalclasses}`}>
                <div className="grid grid-flow-col items-center justify-start gap-[12px]">
                    {icon && <DynamicIcon name={icon} size={24} />}
                    {image &&
                        <>
                            <Image src={`/images/${image}.svg`} width={24} height={24} alt={children} className="block dark:hidden" />
                            <Image src={`/images/dark-${image}.svg`} width={24} height={24} alt={children} className="dark:block hidden" />
                        </>
                    }
                    <div className="grid grid-flow-col gap-3 items-center">
                        <div className="grid grid-flow-col items-center">
                            <div className="grid">
                                <span className="poppins-regular text-[14px] custom-text-grey-900  leading-[15px] whitespace-nowrap flex items-center gap-[8px]">
                                    {children}
                                    {tag && <ComingSoonText>{tag}</ComingSoonText>}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                {active && (<DynamicIcon name='check' size={18} color='' />)}
            </div>
        </Tooltips>
    );
};

export default AppItem;
